import React, {useId} from 'react';
import {HistoricAlertDTO, Status} from "@energy-advice/alertfan-api-client/dist/lib/generated/api";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {dateToReadableString, primereactDataTableSortDateFunction} from "utils/time-utils";
import ParametersTableBody from "./ParametersTableBody";
import {Alert} from "@energy-advice/alertfan-api-client";
import {stringArrayToTags} from "../../basic/strings-array-to-tags/StringArrayToTags";
import {Tooltip} from "react-tooltip";
import TransposedArrayTable from "./TransposedArrayTable";

type HistoryTagsTable = {
    data: HistoricAlertDTO[]
}

const StatusIconMap: Record<Status, any> = {
    FIRING: <i data-tooltip-content={"Firing"} style={{color: "red"}} className="pi pi-exclamation-triangle"></i>,
    RESOLVED: <i data-tooltip-content={"Resolved"} style={{color: "green"}} className="pi pi-check-circle"></i>
}

const StatusTextMap: Record<Status, any> = {
    FIRING: "Firing",
    RESOLVED: "Resolved"
}

const HistoryTagsTable = ({data}: HistoryTagsTable) => {

    const statusBody = (rowData: HistoricAlertDTO) => {
        const tooltipId = useId().replace(/[^a-zA-Z0-9]/g, "")

        return <>
            <div id={tooltipId} className={"flex align-items-center justify-content-center"}>
                {StatusIconMap[rowData.status]}
            </div>
            <Tooltip anchorSelect={`#${tooltipId}`} content={StatusTextMap[rowData.status]} delayShow={300}/>
        </>
    }


    if (!data) {
        return <></>
    }
    return <DataTable value={data} removableSort size={"small"} responsiveLayout={"scroll"}>
        <Column header={"Started"}
                field={"start"}
                body={(e: HistoricAlertDTO) => e.start ? dateToReadableString(new Date(e.start)) : "-"}
                sortable
                sortFunction={primereactDataTableSortDateFunction}
                style={{whiteSpace: "nowrap"}}
        />
        <Column header={"End"}
                field={"end"}
                body={(e: HistoricAlertDTO) => e.end ? dateToReadableString(new Date(e.end)) : "-"}
                sortable
                sortFunction={primereactDataTableSortDateFunction}
                style={{whiteSpace: "nowrap"}}
        />
        <Column header={"Status"} body={statusBody}/>
        <Column header={"Text"}
                field={"text"}
                sortable
                filter
                showFilterMatchModes={false}
                showFilterMenuOptions={false}
                filterPlaceholder={"Search"}
                filterField="text"
                filterMatchMode={"contains"}
        />
        <Column style={{width: 0}}
                body={(rowData: HistoricAlertDTO) => <TransposedArrayTable properties={rowData.timedTexts}/>}/>
        <Column header={"Topic Tags"}
                field={"topicTags"}
                body={(e: Alert) => stringArrayToTags(e.topicTags)}
                filter
                filterMatchMode={"contains"}
                showFilterMatchModes={false}
                showFilterMenuOptions={false}
                filterPlaceholder={"Tag name"}
        />
        <Column header={"Item Tags"}
                field={"itemTags"}
                body={(e: Alert) => stringArrayToTags(e.itemTags)}
                filter
                filterMatchMode={"contains"}
                showFilterMatchModes={false}
                showFilterMenuOptions={false}
                filterPlaceholder={"Tag name"}
        />
        <Column style={{width: 0}}
                body={(rowData: HistoricAlertDTO) => <ParametersTableBody properties={rowData.properties}/>}/>
    </DataTable>
};

export default HistoryTagsTable;